import Col from "components/ui-elements/Col";
import React from "react";
import CheckboxForm from "./CheckboxForm";
const CheckboxFormCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <CheckboxForm {...rest} margin={margin} />
    </Col>
  );
};

CheckboxFormCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default CheckboxFormCol;